import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import FormGrid from '../components/Grid';
import { FormProvider } from '../store';

import FormLayout from './Form';

export default function FormsGridLayout() {
  return <FormProvider>
    <FormGrid />
    <Router>
      <PrivateRoute path={["/offer/forms/add", "/offer/forms/:id"]} component={FormLayout} />
    </Router>
  </FormProvider>;
}
